import { useState } from 'react';
import { LANGUAGES } from '@sss/i18n';
import { Button, Icon, Sheet } from '../../components';
import { cx } from '../../lib/cx';
import { useI18n } from '../../lib/i18n';

/** Interface languages offered in the picker (launch set, ADR-0011). */
export const PICKER_LANGUAGES = LANGUAGES.filter((l) => l.wave === 'LAUNCH');

export function LanguagePicker({ compact }: { compact?: boolean }) {
  const { lang, setLanguage, t } = useI18n();
  const [open, setOpen] = useState(false);
  const current = PICKER_LANGUAGES.find((l) => l.code === lang) ?? PICKER_LANGUAGES[0]!;
  return (
    <>
      {compact ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label={t('ui.profile.language')}
          className="inline-flex min-h-11 items-center gap-1.5 rounded-full px-3 text-sm font-semibold hover:bg-surface-2"
        >
          <Icon name="globe" size={18} />
          {current.code.toUpperCase()}
        </button>
      ) : (
        <Button variant="secondary" icon="globe" iconEnd="chevronDown" onClick={() => setOpen(true)} block className="justify-between">
          {current.nativeName}
        </Button>
      )}
      <Sheet open={open} onClose={() => setOpen(false)} title={t('ui.profile.language')} closeLabel={t('ui.common.close')}>
        <ul className="flex flex-col gap-1">
          {PICKER_LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                onClick={() => {
                  setLanguage(l.code);
                  setOpen(false);
                }}
                className={cx(
                  'flex min-h-12 w-full items-center justify-between rounded-xl px-3 text-start',
                  l.code === lang ? 'bg-brand-soft font-semibold text-brand' : 'hover:bg-surface-2',
                )}
              >
                <span>
                  {l.nativeName} <span className="text-sm text-muted">· {l.englishName}</span>
                </span>
                {l.code === lang && <Icon name="check" size={18} />}
              </button>
            </li>
          ))}
        </ul>
      </Sheet>
    </>
  );
}
